import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {
  AppConfigService,
  ATableComponent,
  BICompanyOrOrderResponse,
  BIOrderRequest,
  BiService,
  BondDto,
  BondingContractExposureDto,
  BondingContractInquiryVersionCriteriaDto,
  BondingContractInquiryVersionSimpleDto,
  BondVersionCriteriaDto,
  BondVersionService,
  BondVersionSimpleDto,
  BrokerContractVersionCriteriaDto,
  BrokerContractVersionService,
  BrokerContractVersionSimpleDto,
  BusinessReportService,
  ClaimService,
  ClaimVersionCriteriaDto,
  ClaimVersionDto,
  CompanyCriteriaDto,
  CompanyDto,
  CompanyNaceCodeDto,
  CompanyRawDto,
  CompanyService,
  CompanySimpleDto,
  CompanyStatisticsDto,
  ConfirmDialogComponent,
  ContractBaseDto,
  ContractService,
  ContractVersionCriteriaDto,
  ContractVersionService,
  ContractVersionSimpleDto,
  DictionaryBaseDto,
  DictionaryBaseService,
  DictionaryDto,
  DictionaryService,
  ErrorReason,
  FeatureService,
  FormatService,
  GrowlService,
  InquiryService,
  LoggedUserService,
  PolicyContractVersionCriteriaDto,
  PolicyContractVersionService,
  PolicyContractVersionSimpleDto,
  PolicyInquiryVersionCriteriaDto,
  PolicyInquiryVersionSimpleDto,
  RouterService,
  SearchCriteria,
  SearchDataProvider,
  SettingsService,
  TemplateService,
  TemplateSimpleDto,
} from '../../bonding_shared';
import {
  BIReportType,
  BISource,
  BusinessObjectType,
  COMPANY_TYPE_BROKERS,
  CompanyElementaryRight,
  CompanyIdentifierType,
  ContactNoteElementaryRight,
  DocumentType,
  ElementaryRight,
  Feature,
  ImportType,
  LimitRequestType,
  PolicyElementaryRight,
  RepoDocumentElementaryRight,
  ServiceContactElementaryRight,
  ServiceNoteElementaryRight,
  TaskType,
  UserRole,
} from '../../bonding_shared/model/dictionary-ids';
import {ClaimListComponent} from '../claim/components/shared/claim-list.component';
import {PolicyVersionListComponent} from '../policy/components/shared/policy-version-list.component';
import {DocumentListComponent} from '../document';
import {BusinessUtils} from '../../bonding_shared/utils/business-utils';
import {InquiryGuiService} from '../inquiry/services/inquiry-gui.service';
import {PolicyInquiryVersionListComponent} from '../policy/components/shared/policy-inquiry-version-list.component';
import {CompanyGuiService} from './services/company-gui.service';
import {CompanyLegalInsolvencyService} from '../../bonding_shared/services/company-legal-insolvency.service';
import {CompanyRatingsComponent} from './components/shared/company-ratings.component';
import {Observable} from 'rxjs';
import {DateUtils} from '../../bonding_shared/utils/date-utils';
import {Item} from '../../bonding_shared/components/item-dropdown/multi-item-dropdown.component';
// tslint:disable-next-line:max-line-length
import {BondingContractInquiryVersionListComponent} from '../bonding-contract/inquiry/components/shared/bonding-contract-inquiry-version-list.component';
import {BondingContractInquiryService} from '../../bonding_shared/services/bonding-contract-inquiry.service';
import {HttpParams} from '@angular/common/http';
import {ReportDefinition} from '../../bonding_shared/model/report-ids';
import {BiReportListComponent} from '../bi-report/components';
import {ListEmitters} from '../../bonding_shared/components/details-view/list-emitters';
import {ServiceNoteService} from '../service-notes/service-note.service';

@Component({
  selector: 'company-preview',
  templateUrl: './company-preview.component.pug',
  styles: [
    '.statistics-label { display: inline-block; width: 45px; }',
    '.statistics-span-value { display: inline-block; width: 120px; text-align: right }',
    '.statistics-span-currency { display: inline-block; width: 25px; text-align: right }',
  ],
})
export class CompanyPreviewComponent extends ListEmitters implements OnInit {
  public readonly ImportType = ImportType;
  public readonly BusinessObjectType = BusinessObjectType;
  public readonly ContactNoteElementaryRight = ContactNoteElementaryRight;
  public readonly ServiceContactElementaryRight = ServiceContactElementaryRight;
  public readonly ServiceNoteElementaryRight = ServiceNoteElementaryRight;
  public readonly RepoDocumentElementaryRight = RepoDocumentElementaryRight;
  public readonly PolicyElementaryRight = PolicyElementaryRight;
  public readonly CompanyElementaryRight = CompanyElementaryRight;
  @ViewChild(PolicyVersionListComponent) public policyList: PolicyVersionListComponent;
  @ViewChild(PolicyInquiryVersionListComponent)
  public policyInquiryList: PolicyInquiryVersionListComponent;
  @ViewChild(BondingContractInquiryVersionListComponent)
  public bondingContractInquiryList: BondingContractInquiryVersionListComponent;
  @ViewChild('claims', {static: true}) public claims: ClaimListComponent;
  @ViewChild(DocumentListComponent, {static: true}) public documentList: DocumentListComponent;
  @ViewChild('biReports') public biReportList: BiReportListComponent;
  @ViewChild(CompanyRatingsComponent, {static: true}) public companyRatingsComponent: CompanyRatingsComponent;
  @ViewChild('subsidiariesTable') public subsidiariesTable: ATableComponent<CompanySimpleDto>;
  @ViewChild('orderReportConfirm', {static: true}) orderReportConfirmDialog: ConfirmDialogComponent;

  public errors: ErrorReason[] | string;
  public policyDataProvider: SearchDataProvider<PolicyContractVersionCriteriaDto, PolicyContractVersionSimpleDto>;
  public policyInquiryDataProvider: SearchDataProvider<PolicyInquiryVersionCriteriaDto, PolicyInquiryVersionSimpleDto>;
  public claimDataProvider: SearchDataProvider<ClaimVersionCriteriaDto, ClaimVersionDto>;
  public claimRiskDataProvider: SearchDataProvider<ClaimVersionCriteriaDto, ClaimVersionDto>;
  public clientBondDataProvider: SearchDataProvider<BondVersionCriteriaDto, BondVersionSimpleDto>;
  public beneficiaryBondDataProvider: SearchDataProvider<BondVersionCriteriaDto, BondVersionSimpleDto>;
  public contractDataProvider: SearchDataProvider<ContractVersionCriteriaDto, ContractVersionSimpleDto>;
  public bondingContractInquiryDataProvider: SearchDataProvider<
    BondingContractInquiryVersionCriteriaDto,
    BondingContractInquiryVersionSimpleDto
  >;
  public brokerContractDataProvider: SearchDataProvider<
    BrokerContractVersionCriteriaDto,
    BrokerContractVersionSimpleDto
  >;
  public company: CompanyDto;
  public selectedCompany: CompanyDto;
  public mainNaceCodes: CompanyNaceCodeDto[];
  public selectedContract: ContractVersionSimpleDto;
  public statistics: CompanyStatisticsDto;
  public objectNotFound = false;
  public inProgress = false;
  public templates: TemplateSimpleDto[] = [];
  public buyerTemplates: TemplateSimpleDto[] = [];
  public biReportTypes: DictionaryBaseDto[] = [];
  public contractInvolvement: BondingContractExposureDto;
  public companySource: BISource;
  private subsidiariesDataProvider: SearchDataProvider<CompanyCriteriaDto, CompanySimpleDto>;
  private country: DictionaryBaseDto;
  private biReportType: DictionaryBaseDto;
  private biSourceId: number;
  public biCountryId: number;
  private forceOrder = false;

  public limitButtonOptions = [];

  readonly LimitRequestType = LimitRequestType;
  readonly Feature = Feature;
  public selectCompanyLabel = 'company.preview.attach';
  serviceNotesCount: number;
  tabId: number;
  readonly companies = [
    {id: 'creditInsurance', name: 'common.creditInsurance'},
    {id: 'surety', name: 'common.surety'},
  ];

  constructor(
    private companyService: CompanyService,
    private companyGUIService: CompanyGuiService,
    private biService: BiService,
    private legalInsolvencyService: CompanyLegalInsolvencyService,
    private loggedUserService: LoggedUserService,
    private bondVersionService: BondVersionService,
    private dictionaryService: DictionaryService,
    private dictionaryBaseService: DictionaryBaseService,
    private activatedRoute: ActivatedRoute,
    private policyService: PolicyContractVersionService,
    private inquiryService: InquiryService,
    private inquiryGUIService: InquiryGuiService,
    private bondingContractInquiryService: BondingContractInquiryService,
    private claimService: ClaimService,
    private contractVersionService: ContractVersionService,
    private contractService: ContractService,
    private brokerContractService: BrokerContractVersionService,
    private businessReportService: BusinessReportService,
    private growlService: GrowlService,
    private cd: ChangeDetectorRef,
    private formatService: FormatService,
    public appService: AppConfigService,
    private templateService: TemplateService,
    public router: RouterService,
    public settingsService: SettingsService,
    private featureService: FeatureService,
    private serviceNote: ServiceNoteService
  ) {
    super();
    this.selectorNameList = ['SelectedCompany'];
    this.initializeSelectorEmitters(false);
  }

  public get broker(): boolean {
    return this.company.companyType && COMPANY_TYPE_BROKERS.indexOf(this.company.companyType.id) >= 0;
  }

  public get internal(): boolean {
    return this.companySource === BISource.INTERNAL;
  }

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.initializeView(params);
      this.tabId = params.id;
    });
    this.serviceNote.counts$.subscribe((counts) => {
      if (counts[this.tabId] !== undefined) {
        this.serviceNotesCount = counts[this.tabId];
      } else {
        this.serviceNotesCount = 0;
      }
    });
    this.serviceNote.getNotesList(BusinessObjectType.COMPANY, +this.tabId);
  }

  createGrcCheck(id: string) {
    switch (id) {
      case 'creditInsurance':
        this.companyService.createGrcCheck(this.company.id, TaskType.GRC_CHECK_CREDIT_INSURANCE).subscribe({
          next: () => {
            this.growlService.notice('Task has been created!');
          },
          error: (err) => console.error('Error', err),
        });
        break;
      case 'surety':
        this.companyService.createGrcCheck(this.company.id, TaskType.GRC_CHECK_SURETY).subscribe({
          next: () => {
            this.growlService.notice('Task has been created!');
          },
          error: (err) => console.error('Error', err),
        });
        break;
      default:
        console.log('Action not defined');
    }
  }

  refreshSubsidiaries(companyId: number) {
    this.subsidiariesDataProvider.searchCriteria.criteria.parentOfBranch.id = companyId;
    if (this.subsidiariesTable) {
      this.subsidiariesTable.search();
    }
  }

  public newBond(): void {
    const selectedContractId = this.selectedContract ? this.selectedContract.contract.id : 0;
    this.router.toBondDetailsNew(this.company.id, selectedContractId);
  }

  onSelectCompany(selected: CompanyDto): void {
    this.selectedCompany = selected;
    this.selectCompanyLabel = 'company.preview.selectedCompany';
  }

  onReset(): void {
    if (this.selectedCompany === null || !this.selectedCompany) {
      this.selectCompanyLabel = 'company.preview.attach';
    }
  }

  public onSelectContractVersion(contractVersion: ContractVersionSimpleDto): void {
    this.selectedContract = !contractVersion ? null : contractVersion;
  }

  public canOrderReport(): boolean {
    return !this.inProgress;
  }

  public canAccessRating(): boolean {
    return this.internal;
  }

  public openStatistics(): void {
    if (!this.statistics) {
      this.loadStatistics();
    }
  }

  public orderReport() {
    if (!Number.isNaN(this.biSourceId) && this.biSourceId) {
      this.loadOrOrderReport(this.biReportType, this.biSourceId, true);
    }
  }

  public isBrokerCompanyAndUserWithCreateContractRights(): boolean {
    return this.broker && this.loggedUserService.hasRight(ElementaryRight.BROKERCONTRACT_CREATE);
  }

  public isSuperUser(): boolean {
    return this.loggedUserService.hasRight(ElementaryRight.COMPANY_SUPER_USER);
  }

  public cancelOrderingReport() {
    console.log('Resign from ordering report');
  }

  public loadOrOrderReport(
    biReportType: DictionaryBaseDto = <DictionaryBaseDto>{id: BIReportType.COMMERCIAL_REPORT},
    biSourceId: number,
    forceOrder = false
  ): void {
    this.errors = undefined;
    this.inProgress = true;
    this.biReportType = biReportType;
    this.biSourceId = biSourceId;
    const biOrderRequest = <BIOrderRequest>{force: forceOrder};
    biOrderRequest.selectedCompany = this.selectedCompany;
    if (this.company.id) {
      biOrderRequest.companyId = this.company.id;
    } else {
      biOrderRequest.companyRaw = <CompanyRawDto>this.company;
    }
    biOrderRequest.type = biReportType;
    biOrderRequest.country = this.country;
    const observable: Observable<BICompanyOrOrderResponse> = this.biService.getOrOrderCompany(
      biOrderRequest,
      biSourceId
    );
    observable.subscribe(
      (companyOrOrderResponse) => {
        this.inProgress = false;
        if (companyOrOrderResponse.company) {
          this.company = companyOrOrderResponse.company;
          this.forceOrder = this.company.biActualReportExists;
          this.initData(this.company.id);
          if (this.company.id && this.canAccessRating() && this.companyRatingsComponent) {
            this.companyRatingsComponent.reloadRatings();
          }
          if (this.companySource === BISource.INTERNAL) {
            // Reload documents to show BI report that was just retrieved.
            if (this.documentList) {
              this.documentList.search();
            }
          } else {
            // After we have loaded new company to our database, we can switch the view to local company mode.
            this.companySource = BISource.INTERNAL;
          }
          this.errors = companyOrOrderResponse.company.warnings;
          this.cd.detectChanges();
          if (!this.errors || this.errors.length === 0) {
            this.growlService.notice('Report was read. You can open it in "Information report" section.');
          } else {
            this.growlService.warning('No report available! Please check later.');
          }
        } else if (companyOrOrderResponse.orderResponse) {
          this.errors = companyOrOrderResponse.orderResponse.warnings;
          if (!this.errors || this.errors.length === 0) {
            this.growlService.notice('Report was ordered. Wait a few days until Bussiness Inteligence processes it.');
          }
        } else if (companyOrOrderResponse.errors) {
          this.errors = companyOrOrderResponse.errors;
          this.inProgress = false;
          if (this.companySource === BISource.INTERNAL && this.biReportList) {
            this.biReportList.search();
          }
        }
        if (this.isForceOrderReportCondition(biReportType.id)) {
          if (!!this.forceOrder) {
            this.orderReportConfirmDialog.openAndExecuteOnConfirm(
              'company.preview.confirm.actualReport.title',
              'company.preview.confirm.actualReport.msg',
              this.orderReport.bind(this),
              this.cancelOrderingReport.bind(this)
            );
          }
        }
      },
      (error) => {
        this.inProgress = false;
        this.errors = error;
      },
      () => {
        if (biOrderRequest.companyId) {
          this.company.id = biOrderRequest.companyId;
        }
        if (this.company.id) {
          this.initializeInternalCompanyView(this.company.id);
        }
      }
    );
  }

  isForceOrderReportCondition(biReportTypeId: number): boolean {
    return (
      this.company &&
      biReportTypeId !== BIReportType.INVESTIGATION &&
      DateUtils.compare(this.company.lastReportFetchingDate, DateUtils.addDay(DateUtils.today(), -30)) > 0
    );
  }

  public toCompanySearch(): void {
    if (this.internal) {
      this.router.toCompanySearch();
    } else {
      this.router.toCompanySearchExternalByBI(this.companySource ? this.companySource.valueOf() : undefined);
    }
  }

  public loadExternalId(biSourceId: number): void {
    this.biService.loadExternalId(biSourceId, this.company.id).subscribe((c) => {
      this.company = c;
      if (
        !this.company.identifiers ||
        !this.company.identifiers.find(
          (ident) => ident.type.id === CompanyIdentifierType.EXTERNAL_ID && ident.biSource.id === biSourceId
        )
      ) {
        this.errors = 'Can not load external id';
      }
    });
  }

  private setOrderedReportTypes(types: DictionaryDto[]): void {
    types.filter((r) => r.id !== BIReportType.PREMIUM_REPORT).forEach((t) => this.biReportTypes.push(t));
  }

  private initializeView(params: Params): void {
    this.inProgress = false;
    const source: number = +params['source'];
    if (source) {
      const id = params['id'];
      this.biCountryId = +params['countryId'];
      if (!id) {
        this.errors = 'Id must be provided';
        return;
      }
      this.initializeExternalCompanyView(id, source);
    } else {
      this.companySource = BISource.INTERNAL;
      const id = +params['id'];
      if (isNaN(id)) {
        this.objectNotFound = true;
        this.company = undefined;
        this.errors = 'Id ' + id + ' is incorrect';
        return;
      }
      this.initializeInternalCompanyView(id);
      this.loadTemplates();
    }
    this.dictionaryService.getDictionary('BIReportType').subscribe((ort) => this.setOrderedReportTypes(ort));
  }

  private loadStatistics(): void {
    this.companyService.getStatistics(this.company.id).subscribe((statistics) => (this.statistics = statistics));
  }

  private createBondDataProvider(
    clientId: number,
    beneficiaryId: number
  ): SearchDataProvider<BondVersionCriteriaDto, BondVersionSimpleDto> {
    const dp = new SearchDataProvider<BondVersionCriteriaDto, BondVersionSimpleDto>(this.bondVersionService);
    dp.searchCriteria = <SearchCriteria<BondVersionCriteriaDto>>{};
    dp.searchCriteria.criteria = <BondVersionCriteriaDto>{};
    dp.searchCriteria.criteria.bond = <BondDto>{};
    dp.searchCriteria.criteria.beneficiaryId = beneficiaryId;
    dp.searchCriteria.criteria.clientId = clientId;
    return dp;
  }

  private createContractDataProvider(
    clientId: number
  ): SearchDataProvider<ContractVersionCriteriaDto, ContractVersionSimpleDto> {
    const dp = new SearchDataProvider<ContractVersionCriteriaDto, ContractVersionSimpleDto>(
      this.contractVersionService
    );
    dp.searchCriteria = <SearchCriteria<ContractVersionCriteriaDto>>{};
    dp.searchCriteria.criteria = <ContractVersionCriteriaDto>{};
    dp.searchCriteria.criteria.contract = <ContractBaseDto>{};
    dp.searchCriteria.criteria.clientId = clientId;
    dp.searchCriteria.parameters = {};
    return dp;
  }

  private createPolicyDataProvider(companyId: number): void {
    this.policyDataProvider = new SearchDataProvider<PolicyContractVersionCriteriaDto, PolicyContractVersionSimpleDto>(
      this.policyService
    );
    this.policyDataProvider.textSearch = false;
    this.policyDataProvider.searchCriteria = <SearchCriteria<PolicyContractVersionCriteriaDto>>{};
    this.policyDataProvider.searchCriteria.criteria = <PolicyContractVersionCriteriaDto>{};
    this.policyDataProvider.searchCriteria.criteria.last = true;
    this.policyDataProvider.searchCriteria.criteria.linkedCompanyId = companyId;
  }

  private createPolicyInquiryDataProvider(clientId: number): void {
    this.policyInquiryDataProvider = new SearchDataProvider<
      PolicyInquiryVersionCriteriaDto,
      PolicyInquiryVersionSimpleDto
    >(this.inquiryService);
    this.policyInquiryDataProvider.searchCriteria.criteria = <PolicyInquiryVersionCriteriaDto>{};
    this.policyInquiryDataProvider.searchCriteria.criteria.client = <CompanyCriteriaDto>{};
    this.policyInquiryDataProvider.searchCriteria.criteria.client.id = clientId;
    this.policyInquiryDataProvider.searchCriteria.criteria.last = true;
    this.policyInquiryDataProvider.textSearch = false;
  }

  private createClaimDataProvider(
    mainBeneficiaryId: number,
    riskId: number
  ): SearchDataProvider<ClaimVersionCriteriaDto, ClaimVersionDto> {
    const dp = new SearchDataProvider<ClaimVersionCriteriaDto, ClaimVersionDto>(this.claimService);
    dp.textSearch = false;
    dp.searchCriteria = <SearchCriteria<ClaimVersionCriteriaDto>>{};
    dp.searchCriteria.criteria = <ClaimVersionCriteriaDto>{
      last: true,
      claim: {mainBeneficiary: {id: mainBeneficiaryId}, risk: {id: riskId}},
    };
    dp.searchCriteria.criteria.last = true;
    return dp;
  }

  private createSubsidiariesDataProvider(companyId: number): SearchDataProvider<CompanyCriteriaDto, CompanySimpleDto> {
    const dp = new SearchDataProvider<CompanyCriteriaDto, CompanySimpleDto>(this.companyService);
    dp.textSearch = false;
    dp.searchCriteria = <SearchCriteria<CompanyCriteriaDto>>{};
    dp.searchCriteria.criteria = <CompanyCriteriaDto>{
      parentOfBranch: {id: companyId},
    };
    return dp;
  }

  private createBondingContractInquiryDataProvider(
    companyId: number
  ): SearchDataProvider<BondingContractInquiryVersionCriteriaDto, BondingContractInquiryVersionSimpleDto> {
    const dp = BusinessUtils.createBondingContractInquiryVersionDataProvider(this.bondingContractInquiryService);
    dp.searchCriteria.criteria.last = true;
    dp.textSearch = false;
    dp.searchCriteria.criteria.clientId = companyId;
    return dp;
  }

  private initializeInternalCompanyView(id: number): void {
    this.initData(id);
    this.loadInternalCompany(id);
  }

  private initializeExternalCompanyView(id: any, biSourceId: number): void {
    this.company = this.companyGUIService.getCompany(id);
    if (this.company.id) {
      this.companySource = BISource.INTERNAL;
      this.initData(this.company.id);
      if (this.canAccessRating() && this.companyRatingsComponent) {
        this.companyRatingsComponent.reloadRatings();
      }
      this.cd.detectChanges();
    } else {
      this.companySource = biSourceId;
    }
    this.mainNaceCodes = this.filterMainNaceCodes();
  }

  private initData(id: number): void {
    this.createPolicyDataProvider(id);
    this.createPolicyInquiryDataProvider(id);
    this.claimDataProvider = this.createClaimDataProvider(id, null);
    this.claimRiskDataProvider = this.createClaimDataProvider(null, id);
    this.clientBondDataProvider = this.createBondDataProvider(id, null);
    this.contractDataProvider = this.createContractDataProvider(id);
    this.beneficiaryBondDataProvider = this.createBondDataProvider(null, id);
    this.brokerContractDataProvider = BusinessUtils.createBrokerContractVersionDataProvider(this.brokerContractService);
    this.brokerContractDataProvider.searchCriteria.criteria.company.id = id;
    this.brokerContractDataProvider.searchCriteria.criteria.last = true;
    this.subsidiariesDataProvider = this.createSubsidiariesDataProvider(id);
    this.bondingContractInquiryDataProvider = this.createBondingContractInquiryDataProvider(id);
  }

  private loadInternalCompany(id: number): void {
    this.companyService.getCompany(id).subscribe(
      (company) => {
        this.company = company;
        // lazy loading of statistics - request sent only if user opened section
        if (this.statistics) {
          this.loadStatistics();
        }
        this.mainNaceCodes = this.filterMainNaceCodes();
        this.dictionaryService
          .getDictionary('LimitRequestType')
          .subscribe((dicts) => this.setLimitButtonOptions(dicts));
        setTimeout(() => this.refreshSubsidiaries(company.id));
      },
      (error) => {
        this.errors = error;
        this.company = undefined;
      }
    );
  }

  private filterMainNaceCodes(): CompanyNaceCodeDto[] {
    if (this.company && this.company.naceCodes && this.company.naceCodes.length > 0) {
      return this.company.naceCodes.filter((nc) => nc.main);
    }
    return [];
  }

  // TODO: check if there is configuration of document types for offer in DB - templates must be defined
  private loadTemplates(): void {
    // this.loadTemplatesByType(this.templates, DocumentType.WZ, BusinessObjectType.COMPANY);
    this.loadTemplatesByType(this.templates, DocumentType.COMMISSION_REFUND_REQUEST, BusinessObjectType.COMPANY);
    this.loadTemplatesByType(
      this.buyerTemplates,
      DocumentType.COMPANY_PAYMENT_BALANCE_REQUEST,
      BusinessObjectType.COMPANY
    );
    this.loadTemplatesByType(
      this.buyerTemplates,
      DocumentType.COMPANY_PAYMENT_HISTORY_REQUEST,
      BusinessObjectType.COMPANY
    );
  }

  private loadTemplatesByType(templates: TemplateSimpleDto[], type: DocumentType, boType: BusinessObjectType): void {
    this.templateService.findByType(type, boType, null).subscribe((result) => {
      if (result !== undefined && result !== null) {
        result.forEach((r) => templates.push(r));
      }
    });
  }

  setLimitButtonOptions(limitRequestTypes: DictionaryDto[]) {
    const allowedTypes = [LimitRequestType.STANDARD];
    const requestTypes = limitRequestTypes.filter((t) => allowedTypes.includes(t.id));
    const newLimitItems = requestTypes.map((t) => <Item>{id: t.id, parentId: 1, label: t.name});
    this.limitButtonOptions = [];
    this.limitButtonOptions.push(<Item>{id: 1, labelKey: 'company.preview.limit.new', items: newLimitItems});
    this.limitButtonOptions.push(<Item>{id: 2, labelKey: 'company.preview.limit.autoDecision'});
    if (this.loggedUserService.hasRight(CompanyElementaryRight.COMPANY_IMPORT_FILE_LIMIT_MASS_DECISION)) {
      this.limitButtonOptions.push(<Item>{id: 3, labelKey: 'company.preview.limit.massReduction'});
    }
  }

  addManualRole() {
    this.inProgress = true;
    this.companyService.addManualRole(this.company.id).subscribe((result) => {
      this.company = result;
      this.growlService.notice('Role added');
      this.inProgress = false;
    });
  }

  downloadReportForBroker() {
    let params = new HttpParams();
    params = params.append('brokerId', this.company.id + '');
    this.errors = undefined;
    this.businessReportService.generate(
      ReportDefinition.BROKER_REPORT,
      `report_${this.company.id}.xlsx`,
      params,
      (errorMsg) => (this.errors = errorMsg)
    );
  }
  // export to Excel information about company, solution for Credendo broker
  showDownloadReportForBroker(): boolean {
    return this.featureService.get(Feature.COMPANY_EXPORT_REPORT) && this.broker;
  }

  removeManualRole() {
    this.inProgress = true;
    this.companyService.removeManualRole(this.company.id).subscribe((result) => {
      this.company = result;
      this.growlService.notice('Role removed');
      this.inProgress = false;
    });
  }

  canRemoveManualRole(): boolean {
    return (
      this.featureService.get(Feature.COMPANY_USE_COMPANY_ROLES) &&
      this.loggedUserService.hasLoggedUserRole(UserRole.SUPER_USER)
    );
  }
}
